export const URL_BACKEND_API = process.env.REACT_APP_URLAPI;
export const URL_BACKEND_DATABOKAPI = process.env.REACT_APP_DATAMOK_API
export const TENANT_ID = process.env.REACT_APP_TENANT_ID;
export const URL_TRANSUNION = process.env.REACT_APP_URL_TRANSUNION
export const COD_RECAPTCHA = process.env.REACT_APP_COD_RECAPTCHA;
export const CLI_PUB = process.env.REACT_APP_CLI_PUB;
export const COD_TAG_MANAGER = process.env.REACT_APP_COD_TAG_MANAGER;
export const DOMAIN = process.env.REACT_APP_DOMAIN;

export const REACT_APP_OPENIA_KEY = process.env.REACT_APP_OPENIA_KEY;
export const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const TOKEN_DATA_MOK = process.env.REACT_APP_TOKEN_DATA_MOK;

export const CONSOLE = process.env.REACT_APP_CONSOLE;

export const URL_LEONARDO_API = 'https://cloud.leonardo.ai/api/rest/v1';
export const LEONARDO_USER_ID = '7a026155-a734-4451-8cf6-982bfededc65';
export const LEONARDO_TOKEN_KEY = 'dd020455-2ea3-47f9-a725-8e2b1b3e02ff';
export const PROMPT_GENERIC = "Generate an interior design without deformations, adding or removing furniture, changing colors depending on the following characteristics,";
